import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      setLoading: false
    };
  },
  props: {
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    raiseHandList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    rtilCode: {
      type: [String, Number],
      default: ''
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  created() {
    Bus.$on('raiseHand', v => {
      v.visibles = false;
      this.raiseHandList.push(v);
    });
    Bus.$on('denyRaiseHand', v => {
      this.raiseHandList && this.raiseHandList.forEach((item, index) => {
        if (item.rtilCode == v.rtilCode) {
          this.raiseHandList.splice(index, 1);
        }
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          const {
            mark,
            value
          } = val;
          this.raiseHandList && this.raiseHandList.forEach(inVal => {
            if (mark == inVal.rtilCode) inVal.nickName = value;
          });
        }
        if (val.key == 'organization') {
          const {
            mark,
            value
          } = val;
          this.raiseHandList && this.raiseHandList.forEach(inVal => {
            if (mark == inVal.rtilCode) inVal.organization = value;
          });
        }
      });
    });
  },
  computed: {
    ...mapState({
      State: state => state,
      PrivateInfo: state => state.privateInfo
    }),
    handOperateList() {
      const obj = {};
      this.raiseHandList && this.raiseHandList.forEach(v => {
        if (this.State.privateInfo.rtilCode == v.rtilCode) {
          obj[v.rtilCode] = ['rename', 'editTagName', 'addQuestioner', 'cancelPrivateConversation', 'moveParty', 'denyRaiseHand'];
        } else {
          obj[v.rtilCode] = ['rename', 'editTagName', 'addQuestioner', 'startPrivateConversation', 'moveParty', 'denyRaiseHand'];
        }
      });
      return obj;
    }
  },
  methods: {
    attendCallback(obj) {
      const {
        type
      } = obj;
      if (type == 'addQuestioner') {
        this.setQuestioner(obj);
      }
      if (type == 'denyRaiseHand') {
        this.cancelRaiseHand(obj);
      }
      if (type == 'editTagName' || type == 'moveParty') {
        this.$emit('callback', obj);
      }
    },
    redClassName({
      row
    }) {
      let _str = '';
      row.rtilCode == this.PrivateInfo.rtilCode ? _str = 'red-row' : '';
      return _str;
    },
    setQuestioner(item) {
      if (this.setLoading) return;
      this.setLoading = true;
      const params = {
        partyCode: this.State.partyCode,
        module: 'setQuestioner',
        msg: {
          nickName: item.nickName,
          rtilCode: item.rtilCode
        }
      };
      item.visibles = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=43055', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('conferenceHost.setQuestionQueue')
          });
        }
        setTimeout(() => {
          this.setLoading = false;
        }, 500);
      });
    },
    cancelRaiseHand(item) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'denyRaiseHand',
        msg: {
          nickName: item.nickName,
          rtilCode: item.rtilCode
        }
      };
      item.visibles = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=82193', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('conferenceHost.removeQuestionQueue')
          });
        }
      });
    },
    changeHandList(pageNum) {
      this.$emit('changeHandList', pageNum);
    }
  }
};